"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "providers/5.0.5";
//# sourceMappingURL=_version.js.map